var _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKongsbergCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kongsberg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#C8102E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFDC01"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2,9.9 L4.2,5.9 L6.1,7.8 L8,4.9 L9.9,7.8 L11.8,5.9 L11.8,9.9 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: 10.5,
    width: 7.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.2,
    cy: 5.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.3,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8,
    cy: 5.4,
    r: 0.65
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKongsbergCircle);
export default __webpack_public_path__ + "static/media/kongsberg-circle.51cfa5b303f3307ba217bc62993ade9b.svg";
export { ForwardRef as ReactComponent };